module.exports = __webpack_public_path__ + "static/media/linux-tux.00a9bfa0.svg";